import type { V2InvoiceCardProps } from "../tab-content-types";
import { InvoiceCardContainer } from "./invoice-card-container";

export type InvoiceCardProps = V2InvoiceCardProps;

export const InvoiceCard: FC<InvoiceCardProps> = (props) => (
  <InvoiceCardContainer {...props} defaultExpanded />
);

export const CompactInvoiceRow: FC<InvoiceCardProps> = (props) => (
  <InvoiceCardContainer {...props} defaultExpanded={false} />
);
